// Modules
import Vue from 'vue'
import VueRouter from 'vue-router'

// Components
import App from './App.vue'

// Pages
import PageHome from './components/pages/PageHome.vue'
import PageWork from './components/pages/PageWork.vue'
import PageDirectors from './components/pages/PageDirectors.vue'
import TemplateDirectorsSingle from './components/templates/TemplateDirectorsSingle.vue'
import PageContact from './components/pages/PageContact.vue'
import PageVideoPlayer from './components/pages/VideoPlayer/PageVideoPlayer.vue'
import Page404 from './components/pages/Page404.vue'
import Test from './components/pages/test.vue'

import utils from './utils/utils'
import params from './utils/params'
import MyEmitter from './helpers/MyEmitter'


const devVersion = 5

console.log("3.1 " + devVersion)


// cleear console
console.log = () => 1

const domConsole = false
window.addConsole = () => true

if(domConsole){
  let myconsole = document.createElement("pre")
  myconsole.id = "myconsole"
  Object.assign(myconsole.style, {
    border: "3px solid blue",
    color: "green",
    position: "absolute",
    backgroundColor: "grey",
    zIndex: 100000,
    top: 0,
    left: 0,
    width: "70vw",
    maxHeight: "70vh",
    overflow: "auto",
    whiteSpace: "pre-line",
    opacity: .85
  })


  document.body.appendChild(myconsole)

  document.getElementById("myconsole").textContent = window.navigator.userAgent

  document.getElementById("myconsole").textContent += `
    -----
    version = ${devVersion}
  `

  window.addConsole = (message) => document.getElementById("myconsole").textContent += message

}


/** AUTO CHECK THAT WINDOW HAS NOT CHANGE */
let index = 0
let maxIndex = 20

let size = {
  width: window.innerWidth,
  height: window.innerHeight,
}

let indexIntervall = setInterval(() => {
  index++
  window.addConsole(`
    
  index ${index}
  `)
  if(index > maxIndex) return clearInterval(indexIntervall)

  if(size.width !== window.innerWidth || size.height !== window.innerHeight){
    window.addConsole(`
    
    has changed
    `)
    // has changed
    MyEmitter.emit(params.Events.globalResize)
  }

}, 50)


Vue.config.productionTip = false

/**
 * 
 * Router
 * 
 */
const router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: "/test",
      component: Test
    },
    {
      path: "/",
      name: "home",
      component: PageHome,
      children: [
        {
          path: "work",
          name: "work",
          component: PageWork
        },
      ]
    },
    {
      path: "/contact",
      name: "contact",
      component: PageContact
    },
    {
      path: "/directors",
      name: "directors",
      component: PageDirectors
    },
    {
      path: "/private/:slug",
      name: "private-pages-details",
      component: TemplateDirectorsSingle
    },
    {
      path: "/directors/:slug",
      name: "directors-single",
      component: TemplateDirectorsSingle
    },
    {
      path: "/player/:slug",
      name: "player",
      component: PageVideoPlayer
    },
    {
      path: "/*",
      component: Page404,
      name: "error404"
    }
  ]
})

router.beforeEach((to, from, next) => {

  if(from && from.name){
    document.body.classList.remove("body-page-" + from.name)
  }
  document.body.classList.add("body-page-" + to.name)

  next()
})

Vue.use(VueRouter)

const mobileDetected =  utils.mobileDetected()
console.log("mode = %s", mobileDetected ? "mobile" : "desktop")

if(mobileDetected){
  document.body.classList.add("mobile-detected")
}
new Vue({
  router,
  data: function(){
    return {
      mobileDetected: mobileDetected
    }
  },
  mounted: function(){

    window.addEventListener("resize", () => {

      if(mobileDetected){
        if(window.innerWidth > params.BREAKPOINTS.Desktop){
          window.location.reload()
          return
        }
      } 
      
      // viewport go mobile
      else {
        if(window.innerWidth < params.BREAKPOINTS.Desktop){
          window.location.reload()
          return
        }
      }
    })


  },
  render: h => h(App),
}).$mount('#app')